import { clsx, type ClassValue } from 'clsx';

// v3 ではプレフィックス付きのため tailwind-merge が実質ノーオペ（クラスを認識せず連結のみ）
// だった。v4 で素のユーティリティ名になると twMerge が figma 由来の custom トークン
// （text-button-lg 等のフォントサイズ）を text-色 と誤分類し、競合扱いで text-white 等を
// 落としてしまう。v3 同等挙動に戻すため twMerge は使わず clsx の連結のみとする。
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
